import ContentWrapper from "~/components/ContentWrapper";
import { SUBSECTION_PARAM_NAME, useSearchParamTab } from "~/hooks/useSearchParamTab.ts";
import type { BillingSettings } from "~/modules/billing/api/billingSettings/billingSettingsTypes.ts";
import BillingTabSubNavigation
	from "~/modules/project/components/ProjectDetailsView/components/ProjectBillingSectionTabContent/components/BillingTabSubNavigation.tsx";
import ProjectBillingSettings
	from "~/modules/project/components/ProjectDetailsView/components/ProjectBillingSectionTabContent/components/ProjectBillingSettingsTabContent/ProjectBillingSettings.tsx";
import ProjectInvoicesTabContent
	from "~/modules/project/components/ProjectDetailsView/components/ProjectBillingSectionTabContent/components/ProjectInvoicesTabContent/ProjectInvoicesTabContent.tsx";
import type { ProjectBillingSubsection } from "~/modules/project/types/projectViewTypes.ts";
import { ProjectDetailsTabName } from "~/modules/project/types/projectViewTypes.ts";
import LoadingPage from "~/pages/LoadingPage.tsx";

type Props = {
	clientId: string;
	projectId: string;
	projectBillingSettings?: BillingSettings;
	projectBillingSettingsIsLoading: boolean;
};

const BILLING_SUBSECTIONS: ProjectBillingSubsection[] = [
	ProjectDetailsTabName.BillingSettings,
	ProjectDetailsTabName.Invoices,
];

const ProjectBillingSectionTabContent = ({
	clientId,
	projectId,
	projectBillingSettings,
	projectBillingSettingsIsLoading,
}: Props) => {
	const [activeSubsection] = useSearchParamTab<ProjectBillingSubsection>(
		SUBSECTION_PARAM_NAME,
		BILLING_SUBSECTIONS,
		ProjectDetailsTabName.BillingSettings,
	);

	const showBillingSettings = activeSubsection === ProjectDetailsTabName.BillingSettings;

	return <ContentWrapper className="grid size-full grid-rows-[auto_1fr] overflow-hidden">
		<BillingTabSubNavigation activeSubsection={activeSubsection}
								 projectId={projectId} />
		{activeSubsection === ProjectDetailsTabName.Invoices && <ProjectInvoicesTabContent projectId={projectId} />}
		{showBillingSettings && projectBillingSettingsIsLoading && <LoadingPage />}
		{showBillingSettings && !projectBillingSettingsIsLoading && !projectBillingSettings &&
			<div className="flex h-full flex-col items-center justify-center">
				<p className="text-lg font-semibold text-gray-700">Keine Abrechnungseinstellungen gefunden</p>
				<p className="text-sm text-gray-500">Bitte wenden Sie sich an den Administrator, um die
					Abrechnungseinstellungen für dieses Projekt zu konfigurieren.</p>
			</div>}
		{showBillingSettings && !projectBillingSettingsIsLoading && projectBillingSettings &&
			<ProjectBillingSettings projectBillingSettings={projectBillingSettings}
									clientId={clientId}
									projectId={projectId} />}
	</ContentWrapper>;
};

export default ProjectBillingSectionTabContent;
